(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  function setOpen(section, id, open) {
    var panel = document.getElementById(id);
    if (!panel) return;
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
    var openers = section.querySelectorAll('[data-sv-address-open="' + id + '"]');
    openers.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var first = panel.querySelector('input:not([type="hidden"]), select, textarea');
      if (first) first.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } else if (openers.length) {
      openers[0].focus({ preventScroll: true });
    }
  }

  function initCountrySelects(form) {
    var country = form.querySelector('[data-sv-country]');
    var province = form.querySelector('[data-sv-province]');
    var wrap = form.querySelector('[data-sv-province-wrap]');
    if (!country || !province || !wrap) return;

    var defaultCountry = country.getAttribute('data-default');
    var defaultProvince = province.getAttribute('data-default');

    if (defaultCountry) {
      for (var i = 0; i < country.options.length; i++) {
        if (country.options[i].value === defaultCountry || country.options[i].textContent.trim() === defaultCountry) {
          country.selectedIndex = i;
          break;
        }
      }
    }

    function update() {
      var option = country.options[country.selectedIndex];
      var raw = option ? option.getAttribute('data-provinces') : null;
      var provinces = [];
      if (raw) {
        try {
          provinces = JSON.parse(raw);
        } catch (err) {
          provinces = [];
        }
      }
      province.innerHTML = '';
      if (!provinces.length) {
        wrap.setAttribute('hidden', '');
        return;
      }
      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        if (defaultProvince && pair[0] === defaultProvince) opt.selected = true;
        province.appendChild(opt);
      });
      wrap.removeAttribute('hidden');
    }

    country.addEventListener('change', update);
    update();
  }

  function initAddresses(root) {
    root.querySelectorAll('[data-sv-addresses]').forEach(function (section) {
      if (section.dataset.svAddressesReady === 'true') return;
      section.dataset.svAddressesReady = 'true';

      section.querySelectorAll('[data-sv-address-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-sv-address-open');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          setOpen(section, id, !isOpen);
        });
      });

      section.querySelectorAll('[data-sv-address-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setOpen(section, btn.getAttribute('data-sv-address-close'), false);
        });
      });

      section.querySelectorAll('[data-sv-address-form]').forEach(initCountrySelects);

      section.querySelectorAll('form[data-sv-confirm]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          var message = form.getAttribute('data-sv-confirm');
          if (message && !window.confirm(message)) event.preventDefault();
        });
      });
    });
  }

  function run() {
    initAddresses(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAddresses(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function initCart(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('form.sv-cart__form').forEach(function (form) {
      if (form.dataset.svCartReady === 'true') return;
      form.dataset.svCartReady = 'true';

      var updateBtn = form.querySelector('[data-sv-cart-update]');
      var timer = null;

      function submitUpdate() {
        window.clearTimeout(timer);
        if (updateBtn && typeof form.requestSubmit === 'function') {
          form.requestSubmit(updateBtn);
        } else if (updateBtn) {
          updateBtn.click();
        } else {
          form.submit();
        }
      }

      form.querySelectorAll('[data-sv-cart-qty]').forEach(function (input) {
        input.addEventListener('change', function () {
          var value = parseInt(input.value, 10);
          if (isNaN(value) || value < 0) {
            input.value = 0;
          }
          window.clearTimeout(timer);
          timer = window.setTimeout(submitUpdate, 400);
        });

        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitUpdate();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCart(document);
    });
  } else {
    initCart(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCart(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function () {
  function initLogin(root) {
    root.querySelectorAll('[data-sv-login]').forEach(function (section) {
      if (section.dataset.svLoginReady === 'true') return;
      section.dataset.svLoginReady = 'true';

      var panels = section.querySelectorAll('[data-sv-login-panel]');
      var switches = section.querySelectorAll('[data-sv-login-switch]');

      function show(key) {
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-sv-login-panel') === key;
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
        switches.forEach(function (btn) {
          if (btn.hasAttribute('aria-expanded')) {
            btn.setAttribute('aria-expanded', btn.getAttribute('data-sv-login-switch') === key ? 'true' : 'false');
          }
        });
        var target = section.querySelector('[data-sv-login-panel="' + key + '"]');
        if (target) {
          var focusable = target.querySelector('input, button');
          if (focusable) focusable.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }

      switches.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          show(btn.getAttribute('data-sv-login-switch'));
        });
      });

      if (window.location.hash === '#recover') show('recover');
    });
  }

  function run() {
    initLogin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLogin(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
